import React from 'react'
import { useTranslation, withTranslation } from 'react-i18next'
import LinkButton from '../button/LinkButton'

export type PageErrorProps = {
    title: string
    description: string
    reloadFunction?: () => void
}

export const PageError = (props: PageErrorProps) => {
    const { t } = useTranslation('common')
    const reloadPage = () => {
        window.location.reload()
    }

    return (
        <div className="pageError">
            <span className="pageError__title">{props.title}</span>
            <span className="pageError__description">{props.description}</span>

            <LinkButton
                className="pageError__reloadButton"
                label={t('labels.reloadPage')}
                onClick={
                    props.reloadFunction ? props.reloadFunction : reloadPage
                }
            />
        </div>
    )
}

export default withTranslation('common')(PageError)
